import { OpenWidgetCommand, ViewerBehavior } from '@stereograph/teiaviewer';

export class ShowDevToolsWidgetBhavior extends ViewerBehavior {
  readonly name = 'ShowDevToolsWidgetBehavior';

  override setup(): void {
    super.setup();
    this._viewer.signals.onViewportReady.connect(this.onViewportReady);
  }

  override dispose(): void {
    super.dispose();
    this._viewer.signals.onViewportReady.disconnect(this.onViewportReady);
  }

  onViewportReady = () => {
    const command = new OpenWidgetCommand(this._viewer, 'DevTools');
    command.execute();
  };
}
